import classes from "./TrustBadge.module.scss";
import Image from 'next/image'
import SecureCheckoutLogo from '@/svgs/secure-checkout.png'
import SustainablySouredLogo from '@/svgs/sustainably-soured.png'
import SatisfactionGuaranteedLogo from '@/svgs/satisfaction-guaranteed.png'
import SatisfactionLogo from '@/svgs/satisfaction.png'

const TrustBadge = ({isMobile}) => {
  if (isMobile) {
    return (
      <div className={`${classes['product__row']} container`}>
        <div className={classes['trust-badges']}>
          <div className={classes['trust-badge']}>
            <Image
              src={SatisfactionLogo.src}
              alt=""
              layout="fixed"
              height={50}
              width={50}
            />
          </div>
          <div className={classes['trust-badge']}>
            <Image
              src={SecureCheckoutLogo.src}
              alt=""
              layout="fixed"
              height={25}
              width={25}
            />
            Secure Checkout
          </div>
          <div className={classes['trust-badge']}>
            < Image
              src={SustainablySouredLogo.src}
              alt=""
              layout="fixed"
              height={20}
              width={20}
            />
            Sustainably Sourced
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`${classes['product__row']} container`}>
      <div className={classes['trust-badges']}>
        <div className={classes['trust-badge']}>
          <Image
            src={SecureCheckoutLogo.src}
            alt=""
            layout="fixed"
            height={25}
            width={25}
          />
          Secure Checkout
        </div>
        <div className={classes['trust-badge']}>
          <Image
            className={classes['small-icon']}
            src={SatisfactionLogo.src}
            alt=""
            layout="fixed"
            height={50}
            width={50}
          />
          100% Satisfaction Guarantee
        </div>
        <div className={classes['trust-badge']}>
          < Image
            src={SustainablySouredLogo.src}
            alt=""
            layout="fixed"
            height={25}
            width={25}
          />
          Sustainably Sourced
        </div>
      </div>
    </div>
  );
};

export default TrustBadge;
